import React, { Component } from 'react'
import Layout from './Layout';
import { Form, Icon, Input, Button, Upload, Switch, message, Menu, Dropdown, Select, Radio, Collapse } from 'antd';
import { connect } from 'react-redux';
import { adminRoutes } from '../helpers/adminRoutes';
import { addSection, resetAddSectionData } from '../redux/actions/addSection';
import { Breadcrumb, List, Card } from 'antd';
import { Prompt } from 'react-router-dom';
import { viewSection, resetViewSection } from '../redux/actions/viewSection';
import { sectionList } from '../redux/actions/sectionList';
import { sectionBreadcrumb } from '../redux/actions/sectionBreadcrumb';
import { SERVER_URL } from '../api';
import { Link } from 'react-router-dom';
import { deleteImage } from '../redux/actions/deleteImage';
import { Beforeunload } from 'react-beforeunload';
import TextArea from 'antd/lib/input/TextArea';
import Item from 'antd/lib/list/Item';
import InfiniteScroll from 'react-infinite-scroller';

const { Option } = Select;
const { Panel } = Collapse;



function hasErrors(fieldsError) {
    return Object.keys(fieldsError).some(field => fieldsError[field]);
}

function blocksToContent(blocks) {
    return (blocks || [])
        .filter(b => b.text && b.text.trim().length > 0)
        .map(b => (b.type === 'heading' ? `# ${b.text.trim()}` : b.text.trim()))
        .join('\n\n');
}

// Strips a recognized heading marker (markdown "#"s, or a whole line wrapped in
// "**bold**"/"__bold__") off a line that's already been identified as a heading.
function stripHeadingMarker(line) {
    const md = line.match(/^#{1,6}\s+(.*)$/);
    if (md) return md[1].trim();
    const bold = line.match(/^\*\*(.+)\*\*$/) || line.match(/^__(.+)__$/);
    if (bold) return bold[1].trim();
    return line;
}

// A line reads as a heading if it's explicitly marked up (markdown "#", or wrapped
// in "**bold**"), or if it's ALL CAPS, or a single short Capitalized word - the shape
// a pattern section header ("YOKE", "Sleeves", "Finishing") almost always takes.
// Deliberately conservative: multi-word instruction lines ("CO 80 Sts", "Rep Rows 1-4")
// are common in pattern text and must NOT get flagged, so anything with digits, more
// than one word, or a non-capitalized word falls through as a paragraph line instead.
function looksLikeHeadingLine(line) {
    if (!line) return false;
    if (/^#{1,6}\s+/.test(line)) return true;
    if (/^\*\*(.+)\*\*$/.test(line) || /^__(.+)__$/.test(line)) return true;
    if (/[.,;:]$/.test(line)) return false;
    const isAllCaps = line === line.toUpperCase() && /[A-Z]/.test(line) && line.length <= 40;
    if (isAllCaps) return true;
    return /^[A-Z][a-zA-Z'-]*$/.test(line) && line.length <= 24;
}

// Best-effort heading/paragraph guess for text pasted from a markdown doc or copied
// out of a PDF. Works line-by-line rather than requiring blank lines between blocks,
// since a straight PDF copy is usually one line per visual line with no blank lines
// at all. Only a starting point - the result is plain editable text, so any misread
// heading can just be fixed by hand afterward.
function guessBlocksFromPaste(raw) {
    if (!raw) return [];
    const lines = raw.replace(/\r\n/g, '\n').split('\n');
    const blocks = [];
    let paragraphLines = [];

    const flushParagraph = () => {
        const text = paragraphLines.join('\n').trim();
        if (text) blocks.push({ type: 'paragraph', text });
        paragraphLines = [];
    };

    lines.forEach(rawLine => {
        const line = rawLine.trim();
        if (!line) {
            flushParagraph();
            return;
        }
        if (looksLikeHeadingLine(line)) {
            flushParagraph();
            blocks.push({ type: 'heading', text: stripHeadingMarker(line) });
            return;
        }
        paragraphLines.push(line);
    });
    flushParagraph();

    return blocks;
}

class AddSectionData extends Component {

    constructor(props) {
        super(props)
        this.state = {
            fileList: [],
            status: false,
            totalRecords: 0,
            patternName: null,
            sizeName: null,
            defaulState: false,
            edit: false,
            patternId: '',
            sizeId: '',
            sectionId: '',
            sectionType: 'chart',
            textContent: '',
            textStateInitialized: false
        }
    }
    componentDidUpdate(prevProps) {
        let { location, dispatch, editData } = this.props;
        let path = location.pathname.split('/')
        let patternId = path[2];
        let sizeId = path[3];
        let sectionId = path[4];

        if (editData !== prevProps.editData && editData && editData.data && editData.data.data && !this.state.textStateInitialized) {
            let sectionData = editData.data.data;
            this.setState({
                sectionType: sectionData.sectionType === 'text' ? 'text' : 'chart',
                textContent: (sectionData.textContent && sectionData.textContent.content) || '',
                textStateInitialized: true
            });
        }

        if (location && prevProps.location !== location) {
            dispatch(sectionBreadcrumb(sizeId)).then(response => {

                this.setState({
                    "status": response && response.data[0] && response.data[0].status,
                    "patternName": response && response.data[0] && response.data[0].pattern && response.data[0].pattern.patternName,
                    "sizeName": response && response.data[0] && response.data[0].sizeName
                })
            });
            let data = {
                start: 0,
                length: 1000000,

            }
            dispatch(sectionList({ id: sizeId, ...data })).then(response => {

            })

            if (sectionId) {
                dispatch(viewSection(sectionId)).then(response => {
                    console.log('response 12=> ', response);

                })
            }
            this.setState({ patternId: patternId, sizeId: sizeId, sectionId: sectionId })
            if (sectionId) {
                this.setState({ edit: true })

            }

        }
    }
    componentDidMount() {
        let { location, dispatch } = this.props;
        let path = location.pathname.split('/')
        let patternId = path[2];
        let sizeId = path[3];
        let sectionId = path[4];


        dispatch(sectionBreadcrumb(sizeId)).then(response => {
            this.setState({
                "status": response && response.data[0] && response.data[0].status,
                "patternName": response && response.data && response.data[0] && response.data[0].pattern && response.data[0].pattern.patternName,
                "sizeName": response && response.data[0] && response.data[0].sizeName
            })
        });
        let data = {
            start: 0,
            length: 1000000,

        }
        dispatch(sectionList({ id: sizeId, ...data })).then(response => {
            if (response && response.data && response.data && response.data.recordsTotal) {
                this.setState({ totalRecords: response.data.recordsTotal })
            }
        })
        if (sectionId) {
            dispatch(viewSection(sectionId)).then(response => {
                this.setState({ emails: response && response.data && response.data.sectionUsers })

            })
        }
        this.setState({ patternId: patternId, sizeId: sizeId, sectionId: sectionId })
        if (sectionId) {
            this.setState({ edit: true })
        }
    }


    handleDelete = (e, id, imageName) => {
        const img = imageName;
        e.preventDefault();
        let { dispatch } = this.props;
        dispatch(deleteImage(id._id, img)).then(res => {
            if (res && res.status === 200) {
                dispatch(viewSection(id._id));
            }
        })
    }

    componentWillUnmount() {
        this.setState({ edit: false, id: null });
        let { dispatch } = this.props;
        dispatch(resetViewSection())
        let val = this.props.form.isFieldsTouched();
        if (val === true) {
        } else {

        }
    }
    normFile = e => {
        if (Array.isArray(e)) {
            return e;
        }
        return e && e.fileList;
    };

    // handleChange = ({ file, fileList }) => {

    //     this.setState({ fileList });
    // }

    handleChange = ({ file, fileList }) => {
        let temp = []
        fileList.map(data => {
            const isJpgOrPng = data.type === 'image/jpeg' || data.type === 'image/png' || data.type === 'image/jpg';
            if (!isJpgOrPng) {
                message.error('You can only upload JPG/PNG/JPEG file!');
                return message.error('Sorry you can  upload JPG/PNG/JPEG file !');
            }
            const sizeOfFile = data.size / 1024 / 1024

            const isLt2M = sizeOfFile < 5;
            if (isLt2M === false) {
                return message.error('Sorry you cannot upload a photo larger then 5 MB!');

            }

            else {
                return (
                    temp.push(data)
                )
            }

        })
        this.setState({ fileList: temp });
    }

    _setSectionType = (e) => {
        this.setState({ sectionType: e.target.value });
    }

    // Re-formats whatever's currently in the text box in place: marks lines that
    // look like headings with a leading "#" and normalizes blank-line spacing
    // between blocks. Idempotent - already-marked text round-trips unchanged, so
    // hand edits (adding/removing a "#") survive re-running this.
    _formatHeadings = () => {
        let { textContent } = this.state;
        if (!textContent || textContent.trim().length === 0) {
            message.error('Paste or type some text in first.');
            return;
        }
        this.setState({ textContent: blocksToContent(guessBlocksFromPaste(textContent)) });
    }


    // handleInfiniteOnLoad = () => {
    //     let { emails } = this.state;
    //     this.setState({
    //         loading: true,
    //     });
    //     if (emails.length > 14) {
    //         message.warning('Infinite List loaded all');
    //         this.setState({
    //             hasMore: false,
    //             loading: false,
    //         });
    //         return;
    //     }
    //     // this.fetchData(res => {

    //     //     emails = emails.concat(res.results);
    //     //     this.setState({
    //     //         emails,
    //     //         loading: false,
    //     //     });
    //     // });
    // };


    handleSubmit = (e, id, type) => {

        e.preventDefault()

        let { dispatch } = this.props;

        let { sizeId, fileList, sectionId, edit, patternId, sectionType, textContent } = this.state;

        if (sectionType === 'text' && (!textContent || textContent.trim().length === 0)) {
            message.error('Add some text content before saving a text section.');
            return;
        }

        this.setState({ defaulState: true })

        this.props.form.validateFields((err, values) => {

            if (!err) {
                // Normalize to bare "\n" - browser textareas commonly emit "\r\n", and the
                // mobile app's block splitter only recognizes blank lines made of bare "\n".
                let extraFields = { sectionType, textBody: sectionType === 'text' ? textContent.replace(/\r\n/g, '\n') : undefined };
                if (edit === false) {
                    dispatch(addSection({ ...values, ...extraFields, fileList, "sizeId": sizeId, "patternId": patternId, "sectionId": sectionId })).then(res => {
                        if (res && res.status === 200) {

                            if (type && type === "save") {
                                this.props.history.push(adminRoutes.SECTIONLIST + '/' + patternId + '/' + sizeId);
                                dispatch(resetAddSectionData());
                            }
                            else

                                this.props.history.push(adminRoutes.GRID + '/' + patternId + '/' + sizeId + '/' + res.data.data._id);
                        }
                    })
                }
                else {
                    if (!err && values.sectionName != null) {
                        if (type && type === "editNext") {

                            dispatch(addSection({ ...values, ...extraFields, fileList, "sizeId": sizeId, "id": sectionId }, edit)).then(res => {
                                if (res && res.status === 200) {

                                    this.props.history.push(adminRoutes.GRID + '/' + patternId + '/' + sizeId + '/' + res.data.data._id);
                                }

                            })
                        }
                        else {
                            dispatch(addSection({ ...values, ...extraFields, fileList, "sizeId": sizeId, "id": sectionId }, edit)).then(res => {
                                if (res && res.status === 200) {
                                    this.props.history.push(adminRoutes.SECTIONLIST + '/' + patternId + '/' + sizeId);
                                    this.setState({ edit: false })
                                    dispatch(resetAddSectionData())
                                }
                            })
                        }
                    }
                }

            }
        })
    };




    handleValidationforAlphabtes = (a, b, c) => {
        if (b.match(/^[a-zA-Z ]*$/)) {
            c();
        } else {
            c("Please enter only alphabets")
        }
    }
    handleValidationforNumbers = (a, b, c) => {
        if (b.match(/^[0-9]*$/)) {
            c();
        } else {
            c("Please enter only numbers")
        }
    }

    optionValues(number) {
        let arr = [];
        let { edit } = this.state;
        if (number && number > 0) {
            if (edit === true) {

                for (let i = 1; i <= number; i++) {
                    arr.push(<Option value={i}>{i}</Option>)
                }
            }
            else {
                for (let i = 1; i <= number + 1; i++) {
                    arr.push(<Option value={i}>{i}</Option>)
                }
            }
            return arr;
        }
    }



    render() {
        const { getFieldDecorator, getFieldsError } = this.props.form;
        let { location, editData, prevAddData } = this.props;
        let { fileList, defaulState, patternId, emails, patternName, sizeName, sizeId, totalRecords, edit } = this.state;
        let path = location.pathname.split('/')
        let id = path[2];

        const uploadButton = (
            <div>
                <Icon type="plus" />
                <div className="ant-upload-text">Upload</div>
            </div>
        );

        return (
            <div className="content-box">

                {this.props.form.isFieldsTouched() === true && defaulState === false && <Beforeunload
                    onBeforeunload={() => "You have unsaved changes, are you sure you want to leave?"} />}

                <Prompt
                    when={this.props.form.isFieldsTouched() === true && defaulState === false}
                    message='You have unsaved changes, are you sure you want to leave?'
                />
                <Layout>

                    <div className="bredcrumb-div">
                        <Breadcrumb separator="-">
                            <Breadcrumb.Item><Link to={adminRoutes.PATTERNLIST}>{editData && editData.data && editData.data.pattern && editData.data.pattern.pattern ? editData && editData.data && editData.data.pattern && editData.data.pattern.pattern && editData.data.pattern.pattern.patternName : patternName}</Link></Breadcrumb.Item>
                            <Breadcrumb.Item><Link to={adminRoutes.SIZELIST + "/" + patternId}>{editData && editData.data && editData.data.pattern && editData.data.pattern.sizeName ? editData && editData.data && editData.data.pattern && editData.data.pattern.sizeName : sizeName}</Link></Breadcrumb.Item>
                            <Breadcrumb.Item><Link to={adminRoutes.SECTIONLIST + "/" + patternId + "/" + sizeId}>{editData && editData.data && editData.data.data && editData.data.data.sectionName ? editData && editData.data && editData.data.data && editData.data.data.sectionName : "Sections"}</Link></Breadcrumb.Item>
                        </Breadcrumb>
                    </div>
                    <div className="page-title d-flex">
                        <h2>{edit === true ? "Edit Section" : "Add Section"}</h2>
                    </div>
                    <div className="white-box">
                        <Form layout="horizontal" onSubmit={this.handleSubmit} style={{ width: "50 %" }}>
                            <ul className="filled-ul">
                                <li className="half-width">
                                    <Form.Item >
                                        <label>Section Title</label>
                                        {getFieldDecorator('sectionName', {
                                            rules: [{ required: true, message: 'Please input your section name!' }],
                                            initialValue:
                                                edit === true ? editData && editData.data && editData.data.data &&
                                                    editData.data.data.sectionName :
                                                    prevAddData && prevAddData.data && prevAddData.data.data.sectionName ?
                                                        prevAddData && prevAddData.data && prevAddData.data.data.sectionName : ""
                                        })(
                                            <Input
                                                // prefix={<Icon />}
                                                type="text"
                                                placeholder="Section Name"
                                            />,
                                        )}
                                    </Form.Item>
                                </li>

                                <li className="half-width">
                                    <Form.Item>
                                        <label>Section Type</label>
                                        <div>
                                            <Radio.Group value={this.state.sectionType} onChange={this._setSectionType}>
                                                <Radio.Button value="chart">Chart</Radio.Button>
                                                <Radio.Button value="text">Text</Radio.Button>
                                            </Radio.Group>
                                        </div>
                                    </Form.Item>
                                </li>

                                {this.state.sectionType === 'text' &&
                                    <li>
                                        <Card title="Text Content" className="text-content-card">
                                            <p>
                                                Paste in text (markdown, or copied from a PDF) and hit "Parse Headings" -
                                                lines that look like section headings get a leading "#" added right in
                                                the box below. It's all one editable field, so you can add or remove a
                                                "#" by hand any time to fix anything the parser gets wrong.
                                            </p>
                                            <TextArea
                                                className="text-area-input"
                                                placeholder="Paste or type pattern text here..."
                                                autosize={{ minRows: 10, maxRows: 30 }}
                                                value={this.state.textContent}
                                                onChange={e => this.setState({ textContent: e.target.value })}
                                            />
                                            <div style={{ margin: '10px 0' }}>
                                                <Button type="primary" onClick={this._formatHeadings}>Parse Headings</Button>
                                            </div>
                                        </Card>
                                    </li>
                                }

                                <li>
                                    <Collapse>
                                        <Panel header="Intro / Outro Text (optional)" key="introOutro">
                                            <ul className="d-flex inner-ul ">
                                                <li>
                                                    <Form.Item >
                                                        <label>Intro Text</label>
                                                        {getFieldDecorator('introText', {

                                                            initialValue:
                                                                edit === true ? editData && editData.data && editData.data.data &&
                                                                    editData.data.data.introText && editData.data.data.introText :
                                                                    prevAddData && prevAddData.data && prevAddData.data.data.introText ?
                                                                        prevAddData && prevAddData.data && prevAddData.data.data.introText : ""
                                                        })(
                                                            <TextArea
                                                                className="text-area-input"
                                                                type="text"
                                                                placeholder="Comments..."

                                                            ></TextArea>,
                                                        )}
                                                    </Form.Item>
                                                </li>
                                                <li>
                                                    <Form.Item >
                                                        <label>Outro Text</label>
                                                        {getFieldDecorator('outroText', {

                                                            initialValue: edit === true ? editData && editData.data && editData.data.data &&
                                                                editData.data.data.outroText && editData.data.data.outroText :
                                                                prevAddData && prevAddData.data && prevAddData.data.data.outroText ?
                                                                    prevAddData && prevAddData.data && prevAddData.data.data.outroText : ""
                                                        })(
                                                            <TextArea
                                                                className="text-area-input"
                                                                type="text"
                                                                placeholder="Comments..."
                                                            ></TextArea>,
                                                        )}
                                                    </Form.Item>
                                                </li>
                                            </ul>
                                        </Panel>
                                    </Collapse>
                                </li>
                                <li className="half-width CustomeSelect">
                                    <Form.Item>
                                        <label>Position</label>
                                        {getFieldDecorator('position', {
                                            rules: [{ required: true, message: 'Please input position!' }],

                                            initialValue: edit === true ? editData && editData.data && editData.data.data &&
                                                editData.data.data.position && editData.data.data.position :
                                                prevAddData && prevAddData.data && prevAddData.data.data.position ?
                                                    prevAddData && prevAddData.data && prevAddData.data.data.position : totalRecords && totalRecords === 0 ? 1 : totalRecords + 1
                                        })(
                                            <Select>
                                                {totalRecords && totalRecords > 0 ?

                                                    this.optionValues(totalRecords) :
                                                    <Option key={1}>1</Option>
                                                }
                                            </Select>
                                        )}
                                    </Form.Item>
                                </li>
                                <li className="picture-card">
                                    <Form.Item extra="">
                                        <label>Add Photos</label>
                                        {getFieldDecorator('image'
                                        )(
                                            <Upload
                                                listType="picture-card"
                                                fileList={fileList}
                                                beforeUpload={() => false}
                                                onPreview={this.handlePreview}
                                                onChange={this.handleChange}
                                                defaultFileList={editData && editData.data && editData.data.data ? `${SERVER_URL}uploads/${editData.data.data.image[0]}` :
                                                    prevAddData && prevAddData.data && prevAddData.data.data && prevAddData.data.data.image[0] ?
                                                        `${SERVER_URL} uploads /${prevAddData.data.data.image[0]}` : []
                                                }
                                                multiple={true}
                                            >
                                                {uploadButton}
                                            </Upload>

                                        )}

                                        <div className="upload-images d-flex">
                                            {
                                                editData && editData.data && editData.data.data.image.map((dat, index) => {
                                                    return (
                                                        <div key={index}>
                                                            <img src={`${SERVER_URL}uploads/${dat}`} alt="" />
                                                            <Button className="imag-close" onClick={(e) => this.handleDelete(e, editData.data.data, dat)}>
                                                                <Icon type="close" />
                                                            </Button>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                    </Form.Item>
                                </li>
                                <li className="">
                                    <Form.Item label="Publish">
                                        {getFieldDecorator('status', {
                                            valuePropName: 'checked',
                                            initialValue: edit === true ? editData && editData.data && editData.data.data.status : this.state.status ? this.state.status :
                                                prevAddData && prevAddData.data && prevAddData.data.data.status ?
                                                    prevAddData && prevAddData.data && prevAddData.data.data.status : false
                                        })(<Switch />)}
                                    </Form.Item>
                                </li>
                                {emails && emails !== undefined &&
                                    <li>
                                        <tr>
                                            <label>In-Progress Users ({emails.length})
                                        </label>
                                            <div className="demo-infinite-container">
                                                <InfiniteScroll
                                                    initialLoad={false}
                                                    pageStart={0}
                                                    loadMore={this.handleInfiniteOnLoad}
                                                    hasMore={!this.state.loading && this.state.hasMore}
                                                    useWindow={false}
                                                >
                                                    <List
                                                        dataSource={this.state.emails}
                                                        renderItem={item => (
                                                            <List.Item key={item}>
                                                                <List.Item.Meta
                                                                    description={item}
                                                                />
                                                            </List.Item>
                                                        )}
                                                    >
                                                        {/* {this.state.loading && this.state.hasMore && (
                                                            <div className="demo-loading-container">
                                                                <Spin />
                                                            </div>
                                                        )} */}
                                                    </List>
                                                </InfiniteScroll>
                                            </div>
                                        </tr>
                                    </li>
                                }
                                <li className="btm-btn chat-view-btm">
                                    <Form.Item>
                                        {edit === false &&
                                            <div className="d-flex justify-content-center">
                                                <div className="ChatExitButton">
                                                    < Button type="button" onClick={(e) => this.handleSubmit(e, id, "save")} disabled={hasErrors(getFieldsError())} >
                                                        Save and Exit
                                                    </Button>
                                                </div>
                                                {this.state.sectionType !== 'text' &&
                                                    <div>
                                                        <Button type="primary" onClick={(e) => this.handleSubmit(e, id, "next")} disabled={hasErrors(getFieldsError())} >
                                                            Next</Button>
                                                    </div>
                                                }
                                            </div>
                                        }
                                        {edit === true &&
                                            <Button type="button" onClick={(e) => this.handleSubmit(e)} disabled={hasErrors(getFieldsError())} >
                                                Update
                        </Button>
                                        }
                                        {edit === true && this.state.sectionType !== 'text' &&
                                            <Button type="primary" onClick={(e) => this.handleSubmit(e, id, "editNext")} disabled={hasErrors(getFieldsError())} >
                                                Next
                        </Button>
                                        }
                                    </Form.Item>
                                </li>


                            </ul>

                        </Form>
                    </div>
                </Layout>
            </div >
        )
    }
}



const mapStateToProps = ((state) => {
    let { loading, data, error } = state.addSection
    return {
        loading,
        data,
        error,
        editLoading: state.viewSection.loading,
        editData: state.viewSection.data,
        prevAddData: state.addSection.data,
        editError: state.viewSection.error,
        sectionData: state.sectionList.data

    }
})

const AddSection = Form.create({ name: 'addSection' })(AddSectionData);
export default connect(mapStateToProps)(AddSection);